import { requestApp, WEB_TO_APP } from "common/webview";
import { setTokens, setUserInfo } from "common/auth";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { userStore } from "store/userStore";

/**
 * 로그인 상태 감지 및 토큰 처리 훅
 */
export const useUser = () => {
    const loginState = useAtomValue(userStore.login.stateAtom);

    // 로그인 성공 시 토큰 저장 후 네이티브 앱으로 전송
    useEffect(() => {
        if (loginState.status === "ready") {
            // 토큰은 data에서 가져옴
            const accessToken = loginState.data?.accessToken;
            const refreshToken = loginState.data?.refreshToken;

            if (accessToken) {
                // 1. in-memory 토큰 저장 (common/auth.ts)
                setTokens(accessToken, refreshToken);
                console.log('✅ Tokens saved (in-memory)');

                // 2. 사용자 정보 저장 (응답 데이터에 있는 경우)
                if (loginState.data) {
                    setUserInfo({
                        userId: loginState.data.userId,
                        email: loginState.data.email,
                        nickname: loginState.data.nickName || loginState.data.nickname,
                    });
                }

                // 3. 네이티브 앱으로 토큰 + userId 전송 (SEND_TOKEN은 이메일 로그인 전용 경로)
                requestApp(WEB_TO_APP.SEND_TOKEN, {
                    access_token: accessToken,
                    refresh_token: refreshToken,
                    user_id: loginState.data?.userId,
                });
            }

            // 상태 초기화
            userStore.login.onDefault();
        }
    }, [loginState.status]);
};
